import * as React from 'react';
import {put, call, takeLatest, select} from 'redux-saga/effects';
import { uniqBy } from "lodash";
import * as Api from './api';
import { fetchUser } from '../AdminPanel/features/users/usersAPI';
import { upsertUsers } from '@/common/slice/userList';
import * as ActionConstants from './actions/actionConstants';
import { BUTTON_LOADER,LOG_APPLICATON_ERROR } from "../../containers/WorkkardDetail/actions/actionConstants";
import {
    FETCH_WORKKARD_OWNER_LIST_REQUEST,
    FETCH_WORKKARD_OWNER_LIST_REQUEST_SUCCESS,
    FETCH_WORKKARD_OWNER_LIST_REQUEST_ERROR,
    // CHANGE_WORKKARD_OWNER_RESET_TO_INITIAL_STATE,
    CHANGE_WORKKARD_OWNER_REQUEST,
    CHANGE_WORKKARD_OWNER_REQUEST_ERROR,
    BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST,
    BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST_SUCCESS,
    BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST_ERROR,
    FETCH_ACTIVITY_OWNER_LIST_REQUEST,
    FETCH_ACTIVITY_OWNER_LIST_REQUEST_SUCCESS,
    FETCH_ACTIVITY_OWNER_LIST_REQUEST_ERROR,
    CHANGE_ACTIVITY_OWNER_REQUEST,
    CHANGE_ACTIVITY_OWNER_REQUEST_ERROR,
    // CHANGE_ACTIVITY_OWNER_RESET_TO_INITIAL_STATE,
    BULK_VALIDATE_ACTIVITY_IDS_CHANGE_OWNER_REQUEST,
    BULK_VALIDATE_ACTIVITY_IDS_CHANGE_OWNER_REQUEST_SUCCESS,
    BULK_CHANGE_ACTIVITY_OWNER_REQUEST,
    CHANGE_ACTIVITY_OWNER_REQUEST_SUCCESS
} from '../../components/ChangeOwner/actionConstants';
import { TOOLTIP_DELAY_TIME } from './constants';
import { SHOW_TOOLTIP } from '../../components/Tooltip/constants';
import { SHOW_LOADER, HIDE_LOADER } from  '../../common/actionConstants';
import UserMiniProfile from '../../components/UserMiniProfile';
import MultipleMiniProfile from '../../components/MultipleMiniProfile';
import { HIDE_DIALOGUE_BOX } from '../../components/DialogueBox/actionConstants';
import {CHANGE_ACTIVITY_ASSIGNEE_ERROR_VALIDATION_MESSAGE} from '../../components/ChangeActivityAssignee/constants';
import {CHANGE_WORKKARD_OWNER_ERROR_VALIDATION_MESSAGE, CHANGE_ACTIVITY_OWNER_ERROR_VALIDATION_MESSAGE } from '../../components/ChangeOwner/constants';
import NoteSummary  from '../../components/NoteSummary';
import { updatePanelDataPermissionSet } from '../WorkkardDetail/Saga/middlePanelContainer';
import { updateActivityListingData, getActivityDetail } from '../WorkkardDetail/Saga/leftPanelContainer';
import {RightPanelConstant,ErrorCode} from '../../containers/WorkkardDetail/constants';
import * as WorkkardActionConstants from "../../containers/WorkkardDetail/actions/actionConstants";
import  *  as  PUBLIC_API_ACTIVITY_ACTION from "../../publicApiActions/activityActions";
import { getAxiosError} from "../../common/util";

const delay = (ms) => new Promise(res => setTimeout(res, ms))

function* getActivityOwnerList() {
    try {
        yield put({ type: SHOW_LOADER });
        const usersResponse = yield call(Api.getWorkkardOwnerListV2);
        if(!usersResponse){
            yield put({type : FETCH_ACTIVITY_OWNER_LIST_REQUEST_ERROR, payload : {errorMessage: CHANGE_ACTIVITY_OWNER_ERROR_VALIDATION_MESSAGE[400] } })
        }else{
            const usersList = usersResponse?.users || usersResponse?.data?.users || [];
            const sponsors = usersList.map(user => ({
                UserId: user.id,
                DisplayName: `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.user_name || '',
                Title: user.user_role || '',
                Email: user.email || ''
            }));

            const usersById = {};
            usersList.forEach(user => {
                usersById[user.id] = user;
            });
            yield put(upsertUsers(usersById));

            const getWorkkardDetailData = (state) => state.workkardDetail;
            const workkardDetailData = yield select(getWorkkardDetailData);
            const currentSponsorId = workkardDetailData?.activityDetail?.activityOwnerId;
            const currentSponsor = sponsors.find(sponsor => sponsor.UserId === currentSponsorId) || {};

            const dataObj = {
                currentSponsor,
                sponsors: sponsors.filter(sponsor => sponsor.UserId !== currentSponsorId)
            }
            yield put({ type: FETCH_ACTIVITY_OWNER_LIST_REQUEST_SUCCESS, payload:dataObj });
        }

    } catch (error) {
        yield put({ type: FETCH_ACTIVITY_OWNER_LIST_REQUEST_ERROR, payload : {errorMessage: error} });
    }

    finally{
        yield put({ type: HIDE_LOADER });
    }
}

function* changeActivityOwner({payload}) {
    try {
        yield put({ type: BUTTON_LOADER, payload: { changeOwner: true}});
        const response = yield call(PUBLIC_API_ACTIVITY_ACTION.changeActivityOwner, { activity_id: payload.activity_id, sponser_id: payload.sponser_id });
        response.status = 200;

        if(response?.status != 200){
            if(payload.onError){
                payload.onError();
            }
            yield delay(30)
            const errorMessage = response?.ValidationMsg ? response.ValidationMsg : CHANGE_ACTIVITY_OWNER_ERROR_VALIDATION_MESSAGE[response?.status];
            yield put({type : CHANGE_ACTIVITY_OWNER_REQUEST_ERROR, payload : {errorMessage : errorMessage }})
        }else{
            if(payload.onSuccess){
                payload.onSuccess()
            }
            yield delay(1000)

            const successPayload = {
                status: 200
            }
            yield put ({ type: FETCH_ACTIVITY_OWNER_LIST_REQUEST_SUCCESS, payload:successPayload });
            yield put({ type: CHANGE_ACTIVITY_OWNER_REQUEST_SUCCESS, payload: payload });
            // yield put({ type: CHANGE_ACTIVITY_OWNER_RESET_TO_INITIAL_STATE });
        }

        const getWorkkardDetailData=(state)=>state.workkardDetail;

        const workkardDetailData=yield select(getWorkkardDetailData);
        const { middlePanel } = workkardDetailData;
        const isCombinedView = workkardDetailData.panelVisibility;

        const {activeTab, diaries, logs} = middlePanel;

        const payloadData={
            cId : workkardDetailData.workkardDetail.Id
        }

        yield* updateActivityListingData(payloadData);

        if (activeTab === 2) {
            yield put({ type: WorkkardActionConstants.RESET_MIDDLE_PANEL_INITIAL_STATE_SUCCESS });
            const diaryPayload = {
                cId: payload.WorkkardId,
                type: diaries.type,
                actId: payload.ActivityId,
                skip: 0,
                take: 10,
                sortBy: diaries.sortBy || "SortByDueDate",
                sort: diaries.filter.sort || "OPEN",
                rows: 10,
                todoOwners: diaries.filter.todoOwners,
                filterOption: JSON.stringify(Object.assign([], diaries.filter.filterOption, ["activity", "workkard"]))
            }

            yield put({ type: WorkkardActionConstants.WORKKARD_TODO_OWNERS_REQUEST, payload: diaryPayload })//diary
        }
        else if (activeTab === 3) {
            if (logs.type == 'activity') {
                const logsPayload = {
                    type: 'activity',
                    cId: workkardDetailData.workkardDetail.Id,
                    actId: payload.ActivityId,
                    skip: 0,
                    take: 10
                }
                yield* updatePanelDataPermissionSet({ payload: logsPayload, permission: { isUpdateLogs: true } })
            }
        }

        if (isCombinedView.toggleView == RightPanelConstant.CombinedViewText) {
            const combinedViewPayload = {
                id: workkardDetailData.workkardDetail.Id,
                start: workkardDetailData.combinedView.start,
                end: workkardDetailData.combinedView.end,
            }
            yield put({ type: WorkkardActionConstants.RESET_ALL_COMBINED_VIEW_DATA })
            yield put ({ type: WorkkardActionConstants.SET_ALL_FILES_FOR_DOWNLOAD ,  payload: workkardDetailData.combinedView.downloadFileUrls   })
            yield* updatePanelDataPermissionSet({ payload: combinedViewPayload, permission: { isUpdateCombinedView: true } })
        }

    } catch (error) {
        let axiosError = getAxiosError(error);
            if(axiosError == ErrorCode.Fail) {
                yield put({ type: CHANGE_ACTIVITY_OWNER_REQUEST_ERROR, payload : {errorMessage : axiosError.error } });
            }
    }
    finally{
        yield put({ type: BUTTON_LOADER, payload: { changeOwner: false}});
        yield put({ type: HIDE_DIALOGUE_BOX });
    }
}

function* bulkValidateChangeActivityOwner(action){
    try{
        const response = yield call(Api.bulkValidateChangeActivityOwner, action.type, action.payload);
        if(response.status != 200){
            const errorMessage = response.ValidationMsg ? response.ValidationMsg : CHANGE_ACTIVITY_OWNER_ERROR_VALIDATION_MESSAGE[response.status];
            yield put({type : ActionConstants.SET_VALIDATION_ERROR_MESSAGE, payload : errorMessage })
        }else{
            yield put ({type: BULK_VALIDATE_ACTIVITY_IDS_CHANGE_OWNER_REQUEST_SUCCESS, payload: response.Data})
        }

     }
    catch(error){
    }
}

function* fetchSingleUserInfo(userId) {
    const response = yield call(fetchUser, { userId });
    const userData = response?.Data ?? response?.user ?? response;
    return { status: ErrorCode.Success, Data: userData };
}

function* getUserInfo(action) {
    const { target, userId, type, position, propertylocation, extraData } = action.payload;
    try {
        let userInfoResponse;
        const existingUser = yield select((state)=>state.userList);
        if (type === 'org') {
            userInfoResponse = yield call(Api.fetchOrgInfo, userId);
        } else {
            if (existingUser?.[userId] && Object?.keys(existingUser?.[userId]).length > 0) {
                userInfoResponse = { status: ErrorCode.Success, Data: existingUser[userId] };
            } else {
                userInfoResponse = yield* fetchSingleUserInfo(userId);
                if (userInfoResponse) {
                    yield put(upsertUsers({ [userId]: userInfoResponse }));
                }
            }
        }

        let extraInfoResponse;
        if (extraData) {
            if (existingUser[extraData] && Object.keys(existingUser[extraData]).length > 0) {
                extraInfoResponse = { status: ErrorCode.Success, Data: existingUser[extraData] };
            } else {
                extraInfoResponse = yield* fetchSingleUserInfo(extraData);
                if (extraInfoResponse) {
                    yield put(upsertUsers({ [extraData]: extraInfoResponse }));
                }
            }
        }
        if (userInfoResponse.status == ErrorCode.Success) {
            //yield delay(500);
            yield put ({
                type: SHOW_TOOLTIP,
                payload: {
                    delay: TOOLTIP_DELAY_TIME,
                    target,
                    position,
                    childComponent: <UserMiniProfile user={userInfoResponse} wklocation={propertylocation} extraInfo={extraInfoResponse ? extraInfoResponse : null} />,
                }
            });
        }
        else if(userInfoResponse.status == ErrorCode.UnAuthorize){
            yield put({
                type: LOG_APPLICATON_ERROR,
                payload: { status:userInfoResponse.status }
              });
        }
    } catch (error) {
        yield put({ type: ActionConstants.FETCH_USER_INFO_ERROR, error });
    }
    finally{
        //yield put({ type: HIDE_LOADER });
    }
}

function* getMultipleProfilesInfo(action) {
    const {data, target, propertylocation} = action.payload;
    try {
        //yield put({ type: SHOW_LOADER });
        let uniqData = uniqBy(data, 'id');
        const existingUser = yield select((state)=>state.userList);
        const response = yield uniqData.map( data =>{
            if(data.type=="user"){
                if (existingUser?.[data.id] && Object.keys(existingUser[data.id]).length > 0) {
                    return call(() => ({ ...existingUser[data.id], status: ErrorCode.Success }));
                }
                return call(Api.fetchUserInfo, data.id)
            }
            else if(data.type=="org")

                return call(Api.fetchOrgInfo, data.id)
        });
        let profileData=[];
        response.forEach((item,key)=>{
            if(uniqData.length === 1) {
                profileData.push(Object.assign({}, item, {title: data[0].title}));
            } else {
            data.forEach((data,index)=>{
                 if((item.id || item.Id) == data.id){
                    profileData.push(Object.assign({}, item, {title: data.title}));
                }
            })
         }
        })
        //yield delay(500);
        yield put ({
            type: SHOW_TOOLTIP,
            payload: {
                delay: TOOLTIP_DELAY_TIME,
                target,
                position: 'right',
                childComponent: <MultipleMiniProfile data={profileData} wklocation={propertylocation} />,
            }
        });
    } catch (error) {
        yield put({ type: ActionConstants.FETCH_USER_INFO_ERROR, error });
    }
    finally{
        //yield put({ type: HIDE_LOADER });
    }
}

function* getNoteSummaryInfo(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const { target, noteId} = action.payload;
        const noteSummaryResponse = yield call(Api.fetchNoteSummary, noteId);
        if(noteSummaryResponse.NoteSummary !== ""){
            yield put({
                type: SHOW_TOOLTIP,
                payload: {
                    target,
                    childComponent: <NoteSummary data={noteSummaryResponse} />,

                }
            });
        }
    } catch (error) {
        yield put({ type: ActionConstants.FETCH_NOTE_SUMMARY_REQUEST_ERROR, error });
    }
    finally{
        yield put({ type: HIDE_LOADER });
    }
}



function* fetchActivityReassignUsers(action){
    try {
        const response = yield call(Api.fetchActivityReassignUsers, action.type, action.payload);
        if(response.status != 200){
            const errorMessage = response.ValidationMsg ? response.ValidationMsg : CHANGE_ACTIVITY_ASSIGNEE_ERROR_VALIDATION_MESSAGE[response.status];
            yield put({type : ActionConstants.SET_VALIDATION_ERROR_MESSAGE, payload : errorMessage })

        }else{
            yield put ({ type: ActionConstants.FETCH_BULK_ACTIVITY_REASSIGN_USERS_REQUEST_SUCCESS, payload:response.Data});
        }


    }
    catch (e){
        yield put({ type: ActionConstants.FETCH_BULK_ACTIVITY_REASSIGN_USERS_REQUEST_ERROR });
    }
    finally{
        yield put({ type: HIDE_LOADER });
    }
}

function* getWorkkardOwnerList() {
    try {
        yield put({ type: SHOW_LOADER });
        const usersResponse = yield call(Api.getWorkkardOwnerListV2);
        const usersList = usersResponse?.users || usersResponse?.data?.users || [];
        const sponsors = usersList.map(user => ({
            UserId: user.id,
            DisplayName: `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.user_name || '',
            Title: user.user_role || '',
            Email: user.email || ''
        }));

        const getWorkkardDetailData = (state) => state.workkardDetail;
        const workkardDetailData = yield select(getWorkkardDetailData);
        const currentSponsorId = workkardDetailData?.workkardDetail?.Sponsor;
        const currentSponsor = sponsors.find(sponsor => sponsor.UserId === currentSponsorId) || {};

        const dataObj = {
            currentSponsor,
            sponsors: sponsors.filter(sponsor => sponsor.UserId !== currentSponsorId)
        }
        yield put({ type: FETCH_WORKKARD_OWNER_LIST_REQUEST_SUCCESS, payload:dataObj });
    } catch (error) {
        yield put({ type: FETCH_WORKKARD_OWNER_LIST_REQUEST_ERROR, payload : { errorMessage :error } });
    }
    finally{
        yield put({ type: HIDE_LOADER });
    }
}

function* changeWorkkardOwner({payload}) {
    try {
        yield put({ type: BUTTON_LOADER, payload: { changeOwner: true}});
        const changeWorkkardSponsorResponse = yield call(Api.changeWorkkardSponsor, payload.WorkkardId, { sponsor_id: payload.SponsorId });
        if(!changeWorkkardSponsorResponse || changeWorkkardSponsorResponse.status != 200){
            if(payload.onError){
                payload.onError();
            }
            yield delay(30)
            const errorMessage = changeWorkkardSponsorResponse?.ValidationMsg ? changeWorkkardSponsorResponse.ValidationMsg : CHANGE_WORKKARD_OWNER_ERROR_VALIDATION_MESSAGE[changeWorkkardSponsorResponse?.status];
            yield put({type : CHANGE_WORKKARD_OWNER_REQUEST_ERROR, payload : { errorMessage : errorMessage} })
        }else{
            if(payload.onSuccess){
                payload.onSuccess()
            }

            let successPayload = {
                status: 200
            }
            
            const getWorkkardDetailData=(state)=>state.workkardDetail;
            const toggleCombinedView = (state) => state.workkardDetail.panelVisibility;
    
            const workkardDetailData=yield select(getWorkkardDetailData);
            const isCombinedView=yield select(toggleCombinedView);
    
            const workkardOwnerId = workkardDetailData.workkardDetail.Sponsor;
            const activityId = workkardDetailData.activityDetail.activityId;
            const activityOwnerId = workkardDetailData.activityDetail.activityOwnerId;
            const activityAssigneeId = workkardDetailData.activityDetail.activityAssigneeId;
            const activityTemplateType = workkardDetailData.activityDetail.activityTemplateType;
            const middlePanel = workkardDetailData.middlePanel;
            const {diaries, logs} = middlePanel;
            
            if (workkardOwnerId === activityOwnerId || workkardOwnerId === activityAssigneeId || activityTemplateType === "Supervisor"){
                const payloadData={
                    cId : workkardDetailData.workkardDetail.Id
                }
                yield* updateActivityListingData(payloadData);
    
                const activityPayload = {
                    payload: {
                        actId: activityId
                    }
                }
                yield* getActivityDetail(activityPayload);

                successPayload = {
                    transferStatus: 200
                }
            }

            yield delay(1000);
            yield put ({ type: FETCH_WORKKARD_OWNER_LIST_REQUEST_SUCCESS, payload:successPayload })

            if(payload.callback) 
                payload.callback();

            if(middlePanel.activeTab === 2){
                yield put({ type: WorkkardActionConstants.RESET_MIDDLE_PANEL_INITIAL_STATE_SUCCESS });
                const diaryPayload = {
                    cId: payload.WorkkardId,
                    type: diaries.type,
                    actId: activityId,
                    skip: 0,
                    take: 10,
                    sortBy: diaries.sortBy || "SortByDueDate",
                    sort: diaries.filter.sort || "OPEN",
                    rows: 10,
                    todoOwners: diaries.filter.todoOwners,
                    filterOption:JSON.stringify(Object.assign([], diaries.filter.filterOption, ["activity", "workkard"]))
                }
    
                yield put ({type: WorkkardActionConstants.WORKKARD_TODO_OWNERS_REQUEST, payload:diaryPayload})//diary
            }
            else if(middlePanel.activeTab === 3){
                if( workkardOwnerId === activityOwnerId || workkardOwnerId === activityAssigneeId){
                    const logsPayload = {
                        type: logs.type,
                        cId: workkardDetailData.workkardDetail.Id,
                        actId: activityId,
                        skip: 0,
                        take: 10
                    }
                    yield* updatePanelDataPermissionSet({ payload: logsPayload , permission:{isFetchLogs:true}})
                } else if(logs.type=='workkard'){
                    const logsPayload = {
                        type: 'workkard',
                        cId: workkardDetailData.workkardDetail.Id,
                        actId: '',
                        skip: 0,
                        take: 10
                    }
                    yield* updatePanelDataPermissionSet({ payload: logsPayload , permission:{isFetchLogs:true}})
                }
            }
    
            if (isCombinedView.toggleView==RightPanelConstant.CombinedViewText){
                const combinedViewPayload = {
                    id: workkardDetailData.workkardDetail.Id,
                    start:workkardDetailData.combinedView.start,
                    end : workkardDetailData.combinedView.end
                }
                yield put({type: WorkkardActionConstants.RESET_ALL_COMBINED_VIEW_DATA})
                //yield put ({ type: WorkkardActionConstants.SET_ALL_FILES_FOR_DOWNLOAD ,  payload: workkardDetailData.combinedView.downloadFileUrls   })
                yield* updatePanelDataPermissionSet({ payload: combinedViewPayload , permission:{isUpdateCombinedView:true}})
            }
        }
    } catch (error) {
        yield put({ type: CHANGE_WORKKARD_OWNER_REQUEST_ERROR, payload : { errorMessage : error } });
    }
    finally{
        yield put({ type: BUTTON_LOADER, payload: { changeOwner: false}});
    }
}

function* validChangeActivityAssigneeSaga({type, payload}) {
    try {
        const response = yield call(Api.getValidChangeActivityAssigneeInfo, type, payload);
        if(response.status != 200){
            const errorMessage = response.ValidationMsg ? response.ValidationMsg : CHANGE_ACTIVITY_ASSIGNEE_ERROR_VALIDATION_MESSAGE[response.status];
            yield put({type : ActionConstants.SET_VALIDATION_ERROR_MESSAGE, payload : errorMessage })

        }else{
            yield put({type: ActionConstants.VALIDATE_CHANGE_ACTIVITY_ASSIGNEE_SUCCESS, payload: response.Data})
        }

    }
    catch (error){
        yield put({type: ActionConstants.VALIDATE_CHANGE_ACTIVITY_ASSIGNEE_ERROR, payload:error});
    }
}

function* bulkReassignActivitiesFromViews({type, payload}) {
    try {
        yield put({type: SHOW_LOADER});
        const response = yield call(Api.bulkReassignActivitiesFromViews, type, payload);
        if(response.status == 200){
            yield put({type: HIDE_DIALOGUE_BOX});
        } else {
            yield put({type: ActionConstants.BULK_REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST_ERROR, payload: response});
            const errorMessage = response.ValidationMsg ? response.ValidationMsg : CHANGE_ACTIVITY_ASSIGNEE_ERROR_VALIDATION_MESSAGE[response.status];
            yield put({type : ActionConstants.SET_VALIDATION_ERROR_MESSAGE, payload : errorMessage })

        }
    }
    catch (error){
        yield put({type: ActionConstants.BULK_REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST_ERROR, payload: error});
    }
    finally {
        yield put({ type: HIDE_LOADER });
    }
}

function* validateWorkkardIds({payload}) {
    try {
        const validIds = yield call(Api.validateWorkkardIdsForChangeOwner, payload);
        if(validIds.status != 200){
            const errorMessage = validIds.ValidationMsg ? validIds.ValidationMsg : CHANGE_WORKKARD_OWNER_ERROR_VALIDATION_MESSAGE[validIds.status];
            yield put({type : ActionConstants.SET_VALIDATION_ERROR_MESSAGE, payload : errorMessage })

        }else{
            yield put({ type: BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST_SUCCESS, payload: validIds.Data });
        }

    } catch (error) {
        yield put({ type: BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST_ERROR, error });
    }
}

export default [
    takeLatest(ActionConstants.FETCH_USER_INFO, getUserInfo),
    takeLatest(ActionConstants.FETCH_MULTIPLE_PROFILES,getMultipleProfilesInfo),
    takeLatest(FETCH_ACTIVITY_OWNER_LIST_REQUEST, getActivityOwnerList),
    takeLatest(CHANGE_ACTIVITY_OWNER_REQUEST, changeActivityOwner),
    takeLatest(ActionConstants.FETCH_NOTE_SUMMARY_REQUEST, getNoteSummaryInfo),

    takeLatest(ActionConstants.VALIDATE_CHANGE_ACTIVITY_ASSIGNEE,validChangeActivityAssigneeSaga),
    takeLatest(ActionConstants.BULK_REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST,bulkReassignActivitiesFromViews),
    takeLatest(FETCH_WORKKARD_OWNER_LIST_REQUEST, getWorkkardOwnerList),
    takeLatest(CHANGE_WORKKARD_OWNER_REQUEST, changeWorkkardOwner),
    takeLatest(BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST, validateWorkkardIds),

    takeLatest(BULK_VALIDATE_ACTIVITY_IDS_CHANGE_OWNER_REQUEST, bulkValidateChangeActivityOwner),
    takeLatest(BULK_CHANGE_ACTIVITY_OWNER_REQUEST, changeActivityOwner),

    takeLatest(ActionConstants.FETCH_BULK_ACTIVITY_REASSIGN_USERS_REQUEST, fetchActivityReassignUsers),

];
